import type { NextRouter } from 'next/router';

type Navigate = NextRouter['push'] | NextRouter['replace'];

// When Next's router cannot load the target (a page left open across a deploy asks for the previous build's data),
// it falls back to a full page load, except toward the URL already displayed: it rejects with this invariant instead,
// and the page stays as it is.
const SAME_URL_HARD_NAVIGATION_ERROR = /^Invariant: attempted to hard navigate to the same URL/;

export const navigateOrReload = async (navigate: Navigate, url: string, options?: Parameters<Navigate>[2]) => {
  try {
    return await navigate(url, undefined, options);
  } catch (error) {
    if (!(error instanceof Error) || !SAME_URL_HARD_NAVIGATION_ERROR.test(error.message)) {
      throw error;
    }
    window.location.assign(url);
    return false;
  }
};
